import PropTypes from "prop-types";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ButtonText from "../../common/ButtonText";
import DateFull from "../../common/FormControl/DateFull/DateFullEx";

const useStyles = makeStyles(theme => ({
  btnColClear: {
    color: theme.palette.primary.main,
    fontSize: 10,
    marginTop: 5,
    marginRight: 8,
  },
  btnColSearch: {
    padding: "5px 15px",
    fontWeight: 600,
    color: theme.palette.common.white,
    fontSize: 9,
    backgroundColor: theme.palette.primary.light,
    minWidth: "unset",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: theme.palette.common.neon,
    },
    width: "auto",
    marginTop: 5,
  },
  colSearch: {
    fontWeight: 400,
    "& .MuiInputLabel-shrink": {
      backgroundColor: theme.palette.common.white,
      textTransform: "none",
      fontSize: 11,
    },
    "& .MuiFormControl-root": {
      marginTop: 10,
    },
    "& .MuiInputLabel-root[data-shrink='false']": {
      transform: "none",
      fontSize: 11,
      margin: 10,
    },
    "& legend": {
      maxWidth: 0,
    },
    maxWidth: "fit-content",
    display: "flex",
    flexDirection: "column",
  },
  colSearchIcon: {
    fontSize: 11,
    color: "#ccc",
  },
}));

const ColumnSearchDate = ({
  name,
  value,
  onClear,
  onDateChange,
  onSearch,
}) => {
  const classes = useStyles();

  const [dateError, setDateError] = useState(false);

  return (
    <Box className={classes.colSearch} align="right">
      <DateFull
        disablePortal
        label={<FormattedMessage id="metadata.datetime" />}
        value={value}
        onChange={date => onDateChange(name, date)}
        onError={reason => setDateError(Boolean(reason))}
      />

      <Box>
        <ButtonText
          btnClass={classes.btnColClear}
          label={<FormattedMessage id="btn.clear" />}
          onClick={onClear}
        />

        <Button
          className={classes.btnColSearch}
          disabled={dateError}
          onClick={onSearch}
        >
          <FormattedMessage id="btn.search" />
        </Button>
      </Box>
    </Box>
  );
};

ColumnSearchDate.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.instanceOf(Date),
  onClear: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
};

ColumnSearchDate.defaultProps = {
  value: null,
};

export default ColumnSearchDate;
